import { useState } from 'react'
import {
  useFloating,
  autoUpdate,
  offset,
  shift,
  useDismiss,
  useRole,
  useInteractions,
  useClick,
} from '@floating-ui/react'
import type { PopoverOptions } from './types'

export function usePopover({
  placement = 'top',
  popoverOffset = 5,
  disable,
}: PopoverOptions = {}) {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const { refs, floatingStyles, context } = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    placement,
    whileElementsMounted: autoUpdate,
    middleware: [offset(popoverOffset), shift({ padding: 5 })],
  })

  const click = useClick(context, {
    enabled: !disable,
  })

  const dismiss = useDismiss(context)
  const role = useRole(context)

  const { getReferenceProps, getFloatingProps } = useInteractions([
    click,
    dismiss,
    role,
  ])

  return {
    isOpen,
    refs,
    floatingStyles,
    getFloatingProps,
    getReferenceProps,
    context,
  }
}
